import React, { useState } from "react";
import Datetime from "react-datetime";
import "react-datetime/css/react-datetime.css";

const Evento = ({ fecharEvento, enviarEvento }) => {
  const [titulo, setTitulo] = useState("");
  const [dataHora, setDataHora] = useState(null);
  const [descricao, setDescricao] = useState("");

  const handleEnviarEvento = () => {
    if (titulo.trim() && dataHora && descricao.trim()) {
      enviarEvento({ titulo, dataHora: dataHora.toString(), descricao });
      fecharEvento();
    } else {
      alert("Preencha todos os campos.");
    }
  };

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        background: "rgba(0, 0, 0, 0.5)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 1000,
      }}
    >
      <div
        style={{
          background: "#fff",
          borderRadius: 12,
          padding: 24,
          width: "90%",
          maxWidth: 400,
          textAlign: "center",
        }}
      >
        <h3 style={{ marginBottom: 16 }}>Criar Evento</h3>
        <input
          type="text"
          placeholder="Título do evento"
          value={titulo}
          onChange={(e) => setTitulo(e.target.value)}
          style={{
            width: "100%",
            padding: "8px",
            marginBottom: 16,
            borderRadius: 8,
            border: "1px solid #ccc",
          }}
        />
        <div style={{ marginBottom: 16 }}>
          <Datetime
            value={dataHora}
            onChange={(date) => setDataHora(date)}
            inputProps={{
              placeholder: "Selecione a data e hora",
              style: {
                width: "100%",
                padding: "8px",
                borderRadius: 8,
                border: "1px solid #ccc",
              },
            }}
          />
        </div>
        <textarea
          placeholder="Descrição do evento"
          value={descricao}
          onChange={(e) => setDescricao(e.target.value)}
          rows={4}
          style={{
            width: "100%",
            padding: "8px",
            marginBottom: 16,
            borderRadius: 8,
            border: "1px solid #ccc",
          }}
        />
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <button
            onClick={fecharEvento}
            style={{
              background: "#ccc",
              color: "#333",
              border: "none",
              borderRadius: 8,
              padding: "8px 16px",
              cursor: "pointer",
            }}
          >
            Cancelar
          </button>
          <button
            onClick={handleEnviarEvento}
            style={{
              background: "#51a197",
              color: "#fff",
              border: "none",
              borderRadius: 8,
              padding: "8px 16px",
              cursor: "pointer",
            }}
          >
            Enviar
          </button>
        </div>
      </div>
    </div>
  );
};

export default Evento;